export default "__VITE_ASSET__Cspydjs___"